/* eslint-disable */
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { handleDateCellRenderer } from "../../../../utils/commonFunctions/cellRenderers";
import { Button } from "@mui/material";
import CustomFilter from "../customFilter/CustomFilter";
import CustomFloatingFilter from "../customFloatingFilter/CustomFloatingFilter";
import { IDashboardGridProps } from "../../../../@types/components/dashBoardGridProps.types";
import { useNavigate } from "react-router-dom";
import { ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";
import { Checkbox } from "@material-ui/core";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import convertJSONToCSV from "../../../../utils/commonFunctions/jsonToCsv";
import { formatDecimalNumber } from "../../../../utils/commonFunctions/formatDecimalNumber";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../utils/api";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import { Delete, History } from "@mui/icons-material";
import { CustomDialog } from "../../../shared/customDialog/CustomDialog";
import { CLAIM_STATUS } from "../../../../constants/claimStatus/ClaimStatus";
import BackdropLoader from "../../../shared/backdropLoader/BackdropLoader";
import CustomDateFilter from "../customFilter/CustomDateFilter";
import CustomDateFloatingFilter from "../customFloatingFilter/CustomDateFloatingFilter";
// import { IPaidClaim } from "../../../../@types/PaidClaim.types";

// const handleDateCellRenderer = (params: any) => {
// 	const date = new Date(params.value);
// 	return date.toLocaleDateString();
// };

// interface CustomDateFloatingFilterProps {
// 	onFloatingFilterChanged: (change: any) => void;
// }

// const CustomDateFloatingFilter: React.FC<CustomDateFloatingFilterProps> = (props: any) => {
// 	const [date, setDate] = useState<string | null>(null);

// 	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
// 		const selectedDate = event.target.value;
// 		setDate(selectedDate);
// 		props.onFloatingFilterChanged({ model: selectedDate });
// 	};

// 	useEffect(() => {
// 		// Reset the date picker when the filter is destroyed
// 		return () => {
// 			setDate(null);
// 		};
// 	}, []);

// 	return <input type="date" value={date || ""} onChange={handleChange} style={{ width: "100%", padding: "2px" }} />;
// };

// interface CustomDateFilterProps {
// 	onFilterChanged: (change: any) => void;
// }

// const CustomDateFilter: React.FC<CustomDateFilterProps> = (props: any) => {
// 	const [searchText, setSearchText] = useState<string>("");

// 	const handleSearch = () => {
// 		props.onFilterChanged({ model: searchText });
// 	};

// 	return (
// 		<div>
// 			<input
// 				type="text"
// 				value={searchText}
// 				onChange={(e: any) => setSearchText(e.target.value)}
// 				placeholder="Search..."
// 				style={{ marginRight: "5px" }}
// 			/>
// 			<button onClick={handleSearch}>Search</button>
// 		</div>
// 	);
// };

const DashboardGrid = ({
	paidClaimFilterSchema,
	setPaidClaimFilterSchema,
	setPaidClaims,
	handleSelectRow,
	selectedRowMap,
	state,
	group_number,
	handleClaimStatus,
	members
}: IDashboardGridProps) => {
	const user = localStorage.getItem("@user");
	const [dialogOpen, setDialogOpen] = useState<boolean>(false);
	const [selectedRowId, setSelectedRowId] = useState<string>("");
	const agGridRef = useRef<any>(null);
	const navigate = useNavigate();
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const [userDetails, setUserDetails] = useState<any>(null);
	const [groupOwnerSettings, setGroupOwnerSettings] = useState<any>(null);
	const [isAllSelected, setIsAllSelected] = useState(false);

	const [loading, setLoading] = React.useState(false);
	const handleClose = () => {
		setLoading(false);
	};

	const getGroupOwnerSettingsDetails = useCallback(async () => {
		if (userDetails) {
			const settings = await trackPromise(api.settings.getGroupOwnerSettings(userDetails._id));
			setGroupOwnerSettings(settings);
		}
	}, [userDetails]);

	// const handleExportButtonClick = async () => {
	// 	const response = await api.paidClaim.getAllPaidClaimList({ ...state, group_number: group_number });
	// 	// setAllPaidClaims(response);
	// 	console.log("Exporting data", selectedRowMap);
	// 	if (!response || response.length === 0) {
	// 		alert("No data available to export.");
	// 		return;
	// 	}
	// 	const filteredData = response.filter((item: any) => selectedRowMap.has(item._id));
	// 	if (filteredData.length === 0) {
	// 		alert("Please select at least one row to export.");
	// 		return;
	// 	}

	// 	let excelFileName;
	// 	if (state.is_all_claims) {
	// 		excelFileName = "All Claim Status";
	// 	} else if (state.is_check_status_requested) {
	// 		excelFileName = "Check Status Requested";
	// 	} else if (state.is_closure_letter_required) {
	// 		excelFileName = "Closure Letter Required";
	// 	} else if (state.is_closure_letter_completed) {
	// 		excelFileName = "Closure Letter Completed";
	// 	} else if (state.claim_status === CLAIM_STATUS.expired) {
	// 		excelFileName = "Move To History";
	// 	}
	// 	setLoading(true);
	// 	convertJSONToCSV(response, `IDR - ${excelFileName} - ${group_number}.csv`);
	// 	convertJSONToCSV(filteredData, `IDR - ${excelFileName} - ${group_number}.csv`);
	// 	setLoading(false);
	// };

	//  temporary fix
	const handleExportButtonClick = async () => {
		const response = await api.paidClaim.getAllPaidClaimList({ ...state, group_number: group_number });
		// console.log("Exporting data", selectedRowMap);

		if (!response || response.length === 0) {
			alert("No data available to export.");
			return;
		}
		const filteredData = response.filter((item: any) => selectedRowMap.has(item._id));
		if (!isAllSelected && filteredData.length === 0) {
			alert("Please select at least one row to export.");
			return;
		}

		let excelFileName;
		if (state.is_all_claims) {
			excelFileName = "All Claim Status";
		} else if (state.is_check_status_requested) {
			excelFileName = "Check Status Requested";
		} else if (state.is_closure_letter_required) {
			excelFileName = "Closure Letter Required";
		} else if (state.is_closure_letter_completed) {
			excelFileName = "Closure Letter Completed";
		} else if (state.claim_status === CLAIM_STATUS.expired) {
			excelFileName = "Move To History";
		}
		setLoading(true);

		if (isAllSelected) {
			convertJSONToCSV(response, `IDR - ${excelFileName} - ${group_number}.csv`);
		} else {
			convertJSONToCSV(filteredData, `IDR - ${excelFileName} - ${group_number}.csv`);
		}

		setLoading(false);
	};

	const hanldeNumberCellRenderer = ({ value }: any): any => {
		const numberValue = Number(value);
		if (numberValue) {
			const trimmedValue = formatDecimalNumber(numberValue);
			return <div className="text">{trimmedValue ? `$ ${Number(trimmedValue).toFixed(2)}` : "NaN"}</div>;
		} else {
			return <div className="text">$ 0.00</div>;
		}
	};
	const hanldePercentageCellRenderer = ({ value }: any): any => {
		const numberValue = Number(value);
		if (numberValue) {
			const trimmedValue = formatDecimalNumber(numberValue);
			return <div className="text">{trimmedValue ? `${trimmedValue.toFixed(2)} %` : "NaN"}</div>;
		} else {
			return <div className="text">0.00 %</div>;
		}
	};
	const hanldeTextCellRenderer = ({ value }: any): any => {
		return <div className="text">{value ? value : "N/A"}</div>;
	};

	const hanldeDollarTextCellRenderer = ({ value }: any): any => {
		const isNumber = !isNaN(value);
		return <div>{value ? (isNumber ? `$ ${Number(value).toFixed(2)}` : value) : "N/A"}</div>;
	};

	const handleSeeDetailsClick = () => {
		const focusedCell = agGridRef?.current.api.getFocusedCell();
		const row = agGridRef?.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
		const {
			data: { _id, group_number, claim_number }
		} = row;
		navigate(`/idr/add-record?e=1&&id=${_id}&&gn=${group_number}&&claim_number=${claim_number}`);
	};

	const handleAgGridReady = (params: GridReadyEvent) => {
		// eslint-disable-next-line no-unused-vars
		const { api, columnApi } = params;
		setAgGridAPI(Object.assign({}, agGridAPI, api));
		setAgGridColumnAPI(columnApi);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
		const { api, columnApi } = params;
		api.sizeColumnsToFit();
	};

	const handleActionDetailsButtonRender = () => {
		// return <div>Hi</div>;
		return (
			<Button
				className="ag-grid-cell-button"
				variant="outlined"
				onClick={handleSeeDetailsClick}
				style={{ marginTop: "3px", marginBottom: "6px" }}
			>
				See Details
			</Button>
		);
	};

	const handleTextCellRenderer = ({ value }: any) => {
		const isNumber = !isNaN(value);
		// return <div>{value ? value : "N/A"}</div>;
		return <div>{value ? (isNumber ? `$ ${Number(value).toFixed(2)}` : value) : "N/A"}</div>;
	};

	// const handleCheckboxCellRenderer = ({ value }: any) => {
	// 	return (
	// 		<>
	// 			<Checkbox
	// 				color="primary"
	// 				// checked={selectedRowMap.has(value)}
	// 				inputProps={{ "aria-label": "secondary checkbox" }}
	// 				onChange={() => handleSelectRow(value)}
	// 			/>
	// 		</>
	// 	);
	// };
	const onSelectionChanged = (event: any) => {
		const selectedRows = event.api.getSelectedRows();
		const allRowsCount = event.api.getDisplayedRowCount();
		const selectedIds = selectedRows.map((row: any) => row._id);
		// console.log("Selected IDs:", selectedIds);
		handleSelectRow(selectedIds);

		if (selectedRows.length === allRowsCount && allRowsCount > 0) {
			setIsAllSelected(true);
		} else {
			setIsAllSelected(false);
		}
	};

	const onRowSelected = (event: any) => {
		if (!event.node.isSelected()) {
			// console.log("Row deselected:", event.data);
			handleSelectRow(event.data._id, false);
		} else {
			// console.log("Row selected:", event.data);
			handleSelectRow(event.data._id, true);
		}
	};
	const handleOpenDialog = (memberObjectId: string) => {
		setSelectedRowId(memberObjectId);
		setDialogOpen(true);
	};
	const restoreSelections = (gridApi: any) => {
		gridApi.forEachNode((node: any) => {
			if (selectedRowMap.has(node.data._id)) {
				node.setSelected(true);
			}
		});
	};

	const handleReject = () => {
		setDialogOpen(false);
	};

	const handlMoveHistoryCellRenderer = ({ value }: any) => {
		return (
			<>
				<Button
					variant="outlined"
					className="button-red-light rounded-button"
					onClick={() => handleOpenDialog(value)}
				>
					<History style={{ marginRight: "4px" }} />
					{state.claim_status === CLAIM_STATUS.expired ? "Restore" : "Move to History"}
				</Button>
			</>
		);
	};

	useEffect(() => {
		agGridRef.current.api.setRowData(Object.assign([], members));
		agGridRef.current.api.refreshCells();
	}, [members]);

	useEffect(() => {
		if (user) {
			setUserDetails(JSON.parse(user));
		}
	}, [user]);

	useEffect(() => {
		getGroupOwnerSettingsDetails();
	}, [getGroupOwnerSettingsDetails]);

	// console.log("isAllSelected=====>", isAllSelected);

	return (
		<div>
			<CustomDialog
				claim_object_id={selectedRowId}
				mode={state.claim_status === CLAIM_STATUS.active ? "MOVE" : "RESTORE"}
				handleClaimStatus={handleClaimStatus}
				handleReject={handleReject}
				heading={
					state.claim_status !== CLAIM_STATUS.expired
						? "Are you sure to move this claim to history ?"
						: "Are you sure to restore this claim ?"
				}
				message={
					state.claim_status !== CLAIM_STATUS.expired
						? "By clicking on yes this claim will be move to history. You can restore it from Move to History Option "
						: "By clicking on yes this claim will be restored. "
				}
				open={dialogOpen}
				key={0}
			/>
			<div className="ag-theme-alpine" style={{ height: "500px", width: "100%" }}>
				<AgGridReact
					ref={agGridRef}
					//rowData={paidClaims}
					onGridReady={handleAgGridReady}
					onFirstDataRendered={handleFirstDataRendered}
					//animateRows
					paginationPageSize={6}
					defaultColDef={{
						filter: "agTextColumnFilter",
						floatingFilter: true,
						resizable: true
						//floatingFilterComponentParams: { suppressFilterButton: true },
					}}
					//enableCellChangeFlash={true}
					defaultColGroupDef={{ marryChildren: true }}
					rowSelection={"multiple"}
					onSelectionChanged={onSelectionChanged}
					onRowSelected={onRowSelected}
					frameworkComponents={{
						schema: paidClaimFilterSchema,
						setPayloadSchema: setPaidClaimFilterSchema,
						setParentSchema: setPaidClaims,
						handleDateCellRenderer: handleDateCellRenderer,
						hanldeTextCellRenderer: hanldeTextCellRenderer,
						hanldeDollarTextCellRenderer: hanldeDollarTextCellRenderer,
						hanldeNumberCellRenderer: hanldeNumberCellRenderer,
						hanldePercentageCellRenderer: hanldePercentageCellRenderer,
						// handleCheckboxCellRenderer: handleCheckboxCellRenderer,
						handleActionDetailsButtonRender: handleActionDetailsButtonRender,
						handlMoveHistoryCellRenderer: handlMoveHistoryCellRenderer,
						customFloatingFilter: CustomFloatingFilter,
						customFilter: CustomFilter,
						customDateFilter: CustomDateFilter,
						customDateFloatingFilter: CustomDateFloatingFilter,
						handleTextCellRenderer: handleTextCellRenderer
					}}
					onModelUpdated={(params) => restoreSelections(params.api)}
				>
					<AgGridColumn
						field="_id"
						headerName="Select Category"
						suppressSizeToFit
						// cellRenderer="handleCheckboxCellRenderer"
						filter={false}
						checkboxSelection={true}
						headerCheckboxSelection={true}
						cellRenderer={() => ""}
					></AgGridColumn>
					{groupOwnerSettings && groupOwnerSettings.group_number ? (
						<AgGridColumn
							field="group_number"
							headerName="Group Number"
							suppressSizeToFit
							filter={false}
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.claim_number ? (
						<AgGridColumn
							field="claim_number"
							headerName="Claim #"
							suppressSizeToFit
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.patient_first_name ? (
						<AgGridColumn
							field="patient_first_name"
							headerName="First Name"
							suppressSizeToFit
							// floatingFilterComponentParams={{ suppressFilterButton: true }}
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							cellRenderer="handleTextCellRenderer"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
							cellRendererFramework="hanldeTextCellRenderer"
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.patient_last_name ? (
						<AgGridColumn
							field="patient_last_name"
							headerName="Last Name"
							suppressSizeToFit
							cellRenderer="handleTextCellRenderer"
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.date_of_service ? (
						<AgGridColumn
							field="date_of_service"
							headerName="DOS"
							suppressSizeToFit
							filter="customDateFilter"
							floatingFilterComponent="customDateFloatingFilter"
							cellRenderer="handleDateCellRenderer"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.closure_ltr_date ? (
						<AgGridColumn
							field="closure_ltr_date"
							headerName="Date to send Closure Ltr"
							suppressSizeToFit
							filter="customDateFilter"
							floatingFilterComponent="customDateFloatingFilter"
							// filter="customFilter"
							// floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleDateCellRenderer"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.closure_sent_date ? (
						<AgGridColumn
							field="closure_sent_date"
							headerName="Closure Sent Date"
							suppressSizeToFit
							filter="customDateFilter"
							floatingFilterComponent="customDateFloatingFilter"
							cellRenderer="handleDateCellRenderer"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.total_charge ? (
						<AgGridColumn
							field="total_charge"
							headerName="Total Charge ($)"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleTextCellRenderer"
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.payee ? (
						<AgGridColumn
							field="payee"
							headerName="Payee"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleSSNCellRenderer"
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.discount ? (
						<AgGridColumn
							field="discount"
							headerName="Discount ($)"
							suppressSizeToFit
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleTextCellRenderer"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.savings ? (
						<AgGridColumn
							field="savings"
							headerName="Savings ($)"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="hanldeNumberCellRenderer"
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.allowable ? (
						<AgGridColumn
							field="allowable"
							headerName="Allowable ($)"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="hanldeNumberCellRenderer"
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.copay ? (
						<AgGridColumn
							field="copay"
							headerName="Co-Pay ($)"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="hanldeDollarTextCellRenderer"
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.TPA_fee ? (
						<AgGridColumn
							field="TPA_fee"
							headerName="Nex Fees ($)"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="hanldeNumberCellRenderer"
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.other_fee ? (
						<AgGridColumn
							field="other_fee"
							headerName="Other Fees ($)"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="hanldeDollarTextCellRenderer"
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.net_savings ? (
						<AgGridColumn
							field="net_savings"
							headerName="Net Savings ($)"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="hanldeNumberCellRenderer"
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.percentage_savings ? (
						<AgGridColumn
							field="percentage_savings"
							headerName="Percentage Savings (%)"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="hanldePercentageCellRenderer"
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.paid ? (
						<AgGridColumn
							field="paid"
							headerName="Paid ($)"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="hanldeNumberCellRenderer"
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.cheque_number ? (
						<AgGridColumn
							field="cheque_number"
							headerName="Check Number"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="hanldeTextCellRenderer"
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.agreement_sent ? (
						<AgGridColumn
							field="agreement_sent"
							headerName="Agreement Sent"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="hanldeTextCellRenderer"
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.cheque_mailed ? (
						<AgGridColumn
							field="cheque_mailed"
							headerName="Check Mailed"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							filter="customDateFilter"
							floatingFilterComponent="customDateFloatingFilter"
							cellRenderer="hanldeDateCellRenderer"
							// filter={false}
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.cheque_received ? (
						<AgGridColumn
							field="cheque_received"
							headerName="Check Received"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							// filter="customDateFilter"
							// floatingFilterComponent="customDateFloatingFilter"
							cellRenderer="hanldeDateCellRenderer"
							// filter={false}
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.cheque_cleared ? (
						<AgGridColumn
							field="cheque_cleared"
							headerName="Check Cleared"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							filter="customDateFilter"
							floatingFilterComponent="customDateFloatingFilter"
							cellRenderer="hanldeDateCellRenderer"
							// filter={false}
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					{groupOwnerSettings && groupOwnerSettings.reissued ? (
						<AgGridColumn
							field="reissued"
							headerName="Reissued"
							suppressSizeToFit
							//floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="hanldeTextCellRenderer"
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
					) : null}
					<AgGridColumn
						field="_id"
						headerName="Move History"
						suppressSizeToFit
						cellRenderer="handlMoveHistoryCellRenderer"
						filter={false}
					></AgGridColumn>
				</AgGridReact>
			</div>
			{members.length !== 0 ? (
				<div className="pf-action-button-container mg-top-20 mg-right-ve10" id="pf-action-button-container">
					<Button className="button-red" variant="contained" onClick={handleExportButtonClick}>
						<span className="button-label-with-icon">Export</span>
						<span>
							<ImportExportIcon className="button-icon" />
						</span>
					</Button>
				</div>
			) : null}
			<BackdropLoader open={loading} handleClose={handleClose} />
		</div>
	);
};

export default DashboardGrid;
